import { selectMyProfile } from "../store/auth/authSlice";
import { useSelector } from "react-redux";
import { t } from "@lingui/macro";
import { ReactNode } from "react";

const CheckAccess = ({
	children,
	perms = [],
	showMessage = false,
	componentReplace,
}: {
  children: ReactNode;
  perms?: string[];
  showMessage?: boolean;
  componentReplace?: ReactNode;
}): JSX.Element => {
	const myProfile = useSelector(selectMyProfile);
	const { permissions = [] } = myProfile;
	let permissionValid = false;

	if (perms.length === 0) {
		permissionValid = true;
	} else {
		permissionValid = permissions.find((el: string) =>
			perms.find((item: string) => item === el),
		)
			? true
			: false;
	}

	if (!permissionValid) {
		return (
      showMessage ? (
      	<p className="text-center mt-4">
      		{t`You do not have permission to access`}!
      	</p>
      ) : componentReplace ? (
      	componentReplace
      ) : null
    ) as JSX.Element;
	}

	return <>{children}</>;
};

export default CheckAccess;
